var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 5.94531C21.7148 6.28516 20.9238 6.53711 20.0508 6.61914C20.9238 6.11523 21.627 5.26562 21.9727 4.33984C21.0996 4.84375 20.2266 5.18359 19.2656 5.35352C18.3867 4.50977 17.25 4 16.0254 4C13.6641 4 11.7363 5.86328 11.7363 8.14844C11.7363 8.48242 11.7363 8.82227 11.8242 9.08008C7.3125 9.08008 4.21875 6.53711 2.12109 4C1.68164 4.5918 1.50586 5.35352 1.50586 6.11523C1.50586 7.55078 2.29688 8.82227 3.43359 9.58398C2.73047 9.50195 2.0332 9.33203 1.50586 9.08008C1.50586 9.08008 1.50586 9.08008 1.50586 9.16211C1.50586 11.1953 2.99414 12.8828 4.92188 13.2227C4.57031 13.3047 4.21875 13.3926 3.7793 13.3926C3.52148 13.3926 3.25781 13.3926 2.99414 13.3105C3.52148 15.0039 5.96484 16.9492 7.88672 16.9492C6.39844 18.0449 5.01562 19 2.25 19C1.89844 19 2.17969 19 1.5 19C3.42188 20.1836 5.70117 20.5 8.0625 20.5C16.0254 20.5 20.3145 14.1543 20.3145 8.65234C20.3145 8.48242 20.3145 8.31836 20.3145 8.14844C21.1875 7.55078 21.8906 6.79492 22.5 5.94531Z",
    fill: "#EAE7E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.3d24353377f3265781c311b3bfc625ab.svg";
export { ForwardRef as ReactComponent };